'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useTranslation } from 'react-i18next'
import { getPageTitleFromPath } from '@/utils/routeLabels'

export default function DocumentTitleSync() {
  const pathname = usePathname()
  const { t, i18n } = useTranslation()

  useEffect(() => {
    const pageTitle = getPageTitleFromPath(pathname, t)
    const appName = t('meta.appName', { defaultValue: 'ManaPNL' })
    document.title = `${pageTitle} | ${appName}`
  }, [pathname, t, i18n.language])

  return null
}
